import {FooterSection, Header} from './sections';
import "./sections/style.css";
import ReactGA from "react-ga4";
import {useEffect} from 'react';
import Maintenance from "../Error/maintenance";
import SEO from '../../components/common/SEO';
import {contactPageSchema} from '../../utils/structuredData';


const Home = () => {
  useEffect(()=>{
    if(process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-ZB9N7T58NE");
      ReactGA.send({ hitType: "pageview", page: "/", title: "Contact Page" });
    }
  },[])
  
  return (
    <div className="w-full homePageContainer relative">
      <SEO
        title="Contact Us - CadencePro.ai | Get in Touch with Our Team"
        description="Have questions about CadencePro? Get in touch with our team for demos, support, or partnership inquiries. We're here to help you transform your project management."
        canonical="/contact"
        keywords="contact cadencepro, project management support, cadencepro demo, AI project planning inquiry"
        structuredData={contactPageSchema}
      />
      <Header />
      <Maintenance />
      <FooterSection />
    </div>
  )
};

export default Home;
